"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var config = { watcher: function () { } };
exports.configure = function (options) {
    Object.assign(config, options);
};
var getQueryName = function (query) {
    try {
        return query.query.definitions[0].name.value;
    }
    catch (err) {
        throw new Error('QueryName could not be found');
    }
};
var getMutationName = function (query) {
    try {
        return query.mutation.definitions[0].name.value;
    }
    catch (err) {
        throw new Error('MutationName could not be found');
    }
};
// determine if an observer (within an observable) is our spy observer
var isSpyObserver = function (observer) {
    var _a = observer._subscription, _b = (_a === void 0 ? {} : _a)._observer, _c = (_b === void 0 ? {} : _b).isSpy, isSpy = _c === void 0 ? false : _c;
    return isSpy;
};
/*
 * Monkey patches an Apollo Client so queries and mutations can be watched
 * @param {ApolloClient}
 * @returns {ApolloClient}
 */
exports.patch = function (client) {
    // NOTE: this never seems to be called
    (function (original) {
        client.query = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var result, query, name_1, variables;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, original.apply(client, args)];
                        case 1:
                            result = _a.sent();
                            try {
                                query = args[0];
                                name_1 = getQueryName(query);
                                variables = query.variables;
                                config.watcher({ type: 'query', name: name_1, variables: variables, success: true, result: result.data });
                            }
                            catch (err) {
                                console.error('Analytics error: ', err);
                            }
                            return [2 /*return*/, result];
                    }
                });
            });
        };
    })(client.query);
    (function (original) {
        client.watchQuery = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // refer https://github.com/apollographql/apollo-client/blob/master/packages/apollo-client/src/core/ObservableQuery.ts
            var observable = original.apply(client, args);
            try {
                var query = args[0];
                var name_2 = getQueryName(query);
                observable.subscribe({
                    isSpy: true,
                    next: function (_a) {
                        var stale = _a.stale, loading = _a.loading, data = _a.data;
                        if (stale || loading)
                            return; // wait for it to be done loading
                        var variables = observable.variables, observers = observable.observers;
                        // Note in Apollo observers are now a Set not an Array so needs conversion
                        var observersArr = Array.from(observers);
                        /* Because we have added an observer to the observable for the
                         * apollo spy, the observable query does not get terminated
                         * (.tearDownQuery). We need to manually terminate this when the
                         * only observer remaining is our apollo spy.
                         * refer https://github.com/apollographql/apollo-client/blob/master/packages/apollo-client/src/core/ObservableQuery.ts#L605
                         */
                        var otherObservers = observersArr.filter(function (obs) { return !isSpyObserver(obs); });
                        var unsubscribe = otherObservers.length === 0;
                        if (unsubscribe) {
                            observable.tearDownQuery();
                        }
                        else {
                            config.watcher({ type: 'query', name: name_2, variables: variables, success: true, result: data });
                        }
                    }
                });
            }
            catch (err) {
                console.error('Analytics error: ', err);
            }
            return observable;
        };
    })(client.watchQuery);
    (function (original) {
        client.mutate = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var result, error, ex_1, mutation, name_3, variables;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, original.apply(client, args)];
                        case 1:
                            result = _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            ex_1 = _a.sent();
                            error = ex_1;
                            return [3 /*break*/, 3];
                        case 3:
                            try {
                                mutation = args[0];
                                name_3 = getMutationName(mutation);
                                variables = mutation.variables;
                                config.watcher(__assign(__assign({ type: 'mutation', name: name_3,
                                    variables: variables, success: error == null }, (error == null && { result: result.data })), (error != null && { error: error })));
                            }
                            catch (err) {
                                console.error('Analytics error: ', err);
                            }
                            if (error)
                                throw error;
                            return [2 /*return*/, result];
                    }
                });
            });
        };
    })(client.mutate);
    return client;
};
